const parseFromInternToHePhoneFormat = (phone) => {
    const regx = /^\+972\s/
    const isHebrew = regx.test(phone)
    return isHebrew ? phone.replace(/^\+972\s/, '0') : phone
}

export default parseFromInternToHePhoneFormat
